import Color from "../../../assets/colors";
import styled from "styled-components";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { animated } from "@react-spring/web";
import { GlobeAltIcon } from "@heroicons/react/24/outline";
import { styled as styling } from "@mui/material/styles";

// Typography Components //
export const Title = styled(Typography)`
  && {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding-top: 15px;
  }
`;

export const ContinueText = styled(Typography)`
  && {
    font-size: 12px;
    text-align: center;
    text-decoration: underline;
    color: #707070;
  }
`;

// Grid Components //
export const OverlayBackground = styled(Grid)`
  && {
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    position: fixed;
    inset: 0;
    z-index: 1500;
  }
`;

export const AppDownloadContent = styled(animated(Grid))`
  && {
    background-color: ${Color.white};
    width: 100%;
    max-width: 480px;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    padding: 20px 20px 24px;
  }
`;

export const TitleContainer = styled(Grid)`
  && {
    margin-bottom: 16px;
    padding: 0 10px;
    width: 100%;
    text-align: center;
  }
`;

export const ContentContainer = styled(Grid)`
  && {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }
`;

export const RowContainer = styled(Grid)`
  && {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${Color.white};
    border-radius: 16px;
  }
`;

export const RowLeft = styled(Grid)`
  && {
    display: flex;
    align-items: center;
    gap: 15px;
    color: #707070;
  }
`;

export const RowRight = styled(Grid)`
  && {
    display: flex;
    justify-content: flex-end;

    #mobile-download-app-button,
    #mobile-continue-web-button {
      border-radius: 10px;
      font-weight: bold;
      font-size: 14px;
      min-width: 103px;
      max-width: 103px;
      height: 38px;
      color: rgba(255, 255, 255, 0.87);
    }

    #mobile-continue-web-button {
      color: #000000;
      opacity: 0.38;
      border: 1px solid rgba(0, 0, 0, 0.38);
    }
  }
`;

export const IconPurple = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 4px;
  display: block;
`;


export const IconGrey = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 0.5px solid #D8D8D8;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RowLabel = styled(Typography)`
  && {
    font-size: 14px;
    font-weight: 400;
    color: #707070;
  }
`;

export const BottomLinkContainer = styled(Grid)`
  && {
    margin-top: 6px;
    text-align: center;
  }
`;


export const BrowserIcon = styling(GlobeAltIcon)(({ theme }) => ({
  height: "28px",
  width: "28px",
  color: "#AEAEAE",

  "& path": {
    strokeWidth: 1,
  },
}));
